$(document).ready(function() {
    var href = window.location.href;
    var filterClickedStatus = "off";
    var clickElement = null;
    var collection = null;
    var count = 0;
    var lang = $('html').attr('lang').substring(0,2);
    var idHide = false;
    var hideMenuItem = false;
    var market = $("#AnnouncementCountryForm .disclosure > button.disclosure__button span").text().split(" | ")[1];
    var filterMarkets = ["Deutschland","Österreich"];

    // hide market based menu items
    if($("header").hasClass("header--has-menu")) {
        var menuIDs = {
            "de": [
                "HeaderMenu-dummy"
                // "HeaderMenu-totaalconcept-waterzuivering-vloeibaar-chloor-beni-twin",
                // "HeaderMenu-shop-waterzuivering-waterzuivering-met-vloeibaar-chloor",
                // "HeaderDrawer-totaalconcept-waterzuivering-vloeibaar-chloor-beni-twin",
                // "HeaderDrawer-shop-waterzuivering-waterzuivering-met-vloeibaar-chloor"
            ]
        };
        try {
            idHide = menuIDs[lang];
        }
        catch (err) {
            //not found
            idHide = false;
        }
        if (idHide) {
            var i;
            for (i = 0; i < idHide.length; ++i) {
                hideMenuItem = $("header nav > ul.list-menu").find("a#" + idHide[i]).remove();
            }
        }
    }
 
    if (href.indexOf("/cart") > -1) {
        
        // Policy consent form translations
        (function () {
            const translations = {
                nl: {
                    agree: 'Ik ga akkoord met de algemene voorwaarden',
                    policy: 'Lees ons beleid hier'
                },
                fr: {
                    agree: 'J\'accepte les conditions générales',
                    policy: 'Lire notre politique ici'
                },
                de: {
                    agree: 'Ich stimme den Allgemeinen Geschäfts- bedingungen zu',
                    policy: 'Lesen Sie hier unsere Richtlinie'
                },
                es: {
                    agree: 'Acepto los términos y condiciones',
                    policy: 'Leer nuestra política aquí'
                },
                en: {
                    agree: 'I agree to the terms and conditions',
                    policy: 'Read our policy here'
                },
                pt: {
                    agree: 'Concordo com os termos e condições',
                    policy: 'Leia nossa política aqui'
                },
                it: {
                    agree: 'Accetto i termini e le condizioni',
                    policy: 'Leggi la nostra politica qui'
                },
                da: {
                    agree: 'Jeg accepterer vilkårene og betingelserne',
                    policy: 'Læs vores politik her'
                }
            };

            function getLocale() {
                return (
                    document.documentElement.lang ||
                    Shopify?.locale ||
                    'en'
                ).toLowerCase().split('-')[0];
            }

            function translateRaleWidget(scope = document) {
                const locale = getLocale();
                const t = translations[locale] || translations.en;

                scope.querySelectorAll('.rale-widget .rale-message').forEach((label) => {
                    const link = label.querySelector('.rale-policy');
                    if (!link) return;

                    link.textContent = t.policy;

                    const textNodes = [...label.childNodes].filter(
                        (node) => node.nodeType === Node.TEXT_NODE
                    );

                    if (textNodes.length) {
                        textNodes[0].textContent = t.agree + ' ';
                    } else {
                        label.insertBefore(document.createTextNode(t.agree + ' '), link);
                    }
                });
            }

            function initRaleTranslationObserver() {
                translateRaleWidget();

                const observer = new MutationObserver((mutations) => {
                    let shouldRun = false;

                    mutations.forEach((mutation) => {
                        mutation.addedNodes.forEach((node) => {
                            if (
                                node.nodeType === 1 &&
                                (
                                node.matches?.('.rale-widget') ||
                                node.querySelector?.('.rale-widget') ||
                                node.matches?.('.cart-drawer, .drawer, cart-drawer, .cart__footer, form[action="/cart"]') ||
                                node.querySelector?.('.cart-drawer, .drawer, cart-drawer, .cart__footer, form[action="/cart"]')
                                )
                            ) {
                                shouldRun = true;
                            }
                        });
                    });

                    if (shouldRun) translateRaleWidget();
                });

                observer.observe(document.body, {
                    childList: true,
                    subtree: true
                });
            }

            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', initRaleTranslationObserver);
            } else {
                initRaleTranslationObserver();
            }
        })();

        // free shipping threshold translator and update handler
        const box = document.getElementById('free-shipping-popup');
        if (!box) return;

        const threshold = parseInt(box.dataset.threshold || '0', 10);
        const moneyFormat = box.dataset.moneyFormat || '${{amount}}';
        const languageCode = (box.dataset.languageCode || 'en').toLowerCase().split('-')[0];
        const hasPalletShipping = box.dataset.hasPalletShipping === 'true';

        const messageEl = document.getElementById('free-shipping-message');
        const progressEl = document.getElementById('free-shipping-progress');

        const translations = {
            en: {
                pallet: 'This cart contains pallet-shipping products. Free shipping is not applicable.',
                unlocked: 'You’ve unlocked free shipping.',
                remaining: 'Spend {{amount}} more to get free shipping.'
            },
            nl: {
                pallet: 'Deze winkelwagen bevat producten met palletverzending. Gratis verzending is niet van toepassing.',
                unlocked: 'Je hebt gratis verzending ontgrendeld.',
                remaining: 'Besteed nog {{amount}} om gratis verzending te krijgen.'  
            },
            fr: {
                pallet: 'Ce panier contient des produits expédiés sur palette. La livraison gratuite ne s’applique pas.',
                unlocked: 'Vous avez débloqué la livraison gratuite.',
                remaining: 'Dépensez encore {{amount}} pour bénéficier de la livraison gratuite.'
            },
            de: {
                pallet: 'Dieser Warenkorb enthält Produkte mit Palettenversand. Kostenloser Versand ist nicht verfügbar.',
                unlocked: 'Du hast den kostenlosen Versand freigeschaltet.',
                remaining: 'Gib noch {{amount}} aus, um kostenlosen Versand zu erhalten.'
            },
            es: {
                pallet: 'Este carrito contiene productos con envío por palé. El envío gratuito no es aplicable.',
                unlocked: 'Has desbloqueado el envío gratuito.',
                remaining: 'Gasta {{amount}} más para conseguir envío gratuito.'
            },
            pt: {
                pallet: 'Este carrinho contém produtos com envio por palete. O envio gratuito não se aplica.',
                unlocked: 'Você desbloqueou o frete grátis.',
                remaining: 'Gaste mais {{amount}} para obter frete grátis.'
            },
            it: {
                pallet: 'Questo carrello contiene prodotti con spedizione su pallet. La spedizione gratuita non è applicabile.',
                unlocked: 'Hai sbloccato la spedizione gratuita.',
                remaining: 'Spendi ancora {{amount}} per ottenere la spedizione gratuita.'
            },
            da: {
                pallet: 'Denne kurv indeholder produkter med palleforsendelse. Gratis levering gælder ikke.',
                unlocked: 'Du har låst op for gratis levering.',
                remaining: 'Brug {{amount}} mere for at få gratis levering.'
            }
        };

        function t() {
            return translations[languageCode] || translations.en;
        }

        function formatMoney(cents, format) {
            const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

            function formatWithDelimiters(number, precision, thousands, decimal) {
                if (isNaN(number) || number == null) return '0';
                const amount = (number / 100).toFixed(precision);
                const parts = amount.split('.');
                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
                return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
            }

            const formatString = format || moneyFormat;
            const match = formatString.match(placeholderRegex);
            if (!match) return formatString;

            const placeholder = match[1];
            let value = '';

            switch (placeholder) {
                case 'amount':
                value = formatWithDelimiters(cents, 2, ',', '.');
                break;
                case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0, ',', '.');
                break;
                case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, '.', ',');
                break;
                case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, '.', ',');
                break;
                default:
                value = formatWithDelimiters(cents, 2, ',', '.');
            }

            return formatString.replace(placeholderRegex, value);
        }

        function renderMessage(cart) {
            if (!messageEl) return;

            if (hasPalletShipping) {
                messageEl.textContent = t().pallet;
                if (progressEl) progressEl.style.width = '0%';
                    return;
            }

            const total = cart && typeof cart.total_price === 'number' ? cart.total_price : 0;
            const remaining = Math.max(threshold - total, 0);
            const progress = threshold > 0 ? Math.min((total / threshold) * 100, 100) : 0;

            if (progressEl) {
                progressEl.style.width = progress + '%';
            }

            if (remaining <= 0) {
                messageEl.textContent = t().unlocked;
            } else {
                messageEl.textContent = t().remaining.replace('{{amount}}', formatMoney(remaining, moneyFormat));
            }
        }

        let refreshTimer = null;
        let lastSeenTotal = null;
        let isFetching = false;

        function refreshCartMessage() {
            if (hasPalletShipping) {
                renderMessage({ total_price: 0 });
                return;
            }

            if (isFetching) return;
            clearTimeout(refreshTimer);

            refreshTimer = setTimeout(function () {
                isFetching = true;

                fetch('/cart.js')
                .then(function (response) {
                    return response.json();
                })
                .then(function (cart) {
                    if (!cart) return;

                    if (lastSeenTotal !== cart.total_price) {
                    lastSeenTotal = cart.total_price;
                    }

                    renderMessage(cart);
                })
                .catch(function () {})
                .finally(function () {
                    isFetching = false;
                });
            }, 120);
        }

        refreshCartMessage();

        document.addEventListener('cart:updated', refreshCartMessage);
        document.addEventListener('change:cart', refreshCartMessage);

        document.body.addEventListener('click', function (event) {
            const quantityButton = event.target.closest(
                '.quantity__button, button[name="plus"], button[name="minus"], [data-quantity-button], .cart-item button'
            );
            if (quantityButton) {
                setTimeout(refreshCartMessage, 250);
            }
        });

        document.body.addEventListener('change', function (event) {
            const quantityInput = event.target.closest(
                'input[name="updates[]"], .quantity__input, [data-quantity-input]'
            );
            if (quantityInput) {
                setTimeout(refreshCartMessage, 250);
            }
        });

        const subtotalNode = document.querySelector('.totals__total-value');

        if (subtotalNode) {
            const subtotalObserver = new MutationObserver(function () {
                refreshCartMessage();
            });

            subtotalObserver.observe(subtotalNode, {
                childList: true,
                subtree: true,
                characterData: true
            });
        }

        const cartForm =
            document.querySelector('form[action="/cart"]') ||
            document.querySelector('.cart') ||
            document.querySelector('.cart__footer');

        if (cartForm) {
            const cartObserver = new MutationObserver(function (mutations) {
                const changed = mutations.some(function (mutation) {
                    return mutation.addedNodes.length || mutation.removedNodes.length || mutation.type === 'characterData';
                });

                if (changed) refreshCartMessage();
            });

            cartObserver.observe(cartForm, {
                childList: true,
                subtree: true,
                characterData: true
            });
        }
    }
    // Translate cookie consent banner
    function initPandectesTranslation(lang) {
        const dict = {
            'We respect your privacy': {
                fr: 'Nous respectons votre vie privée',
                es: 'Respetamos su privacidad',
                pt: 'Respeitamos a sua privacidade.',
                it: 'Rispettiamo la tua privacy',
                de: 'Wir respektieren Ihre Privatsphäre.',
                da: 'Vi respekterer dit privatliv',
                nl: 'Wij respecteren uw privacy'
            },
            'This website is using cookies to enhance your shopping experience': {
                fr: "Ce site web utilise des cookies pour améliorer votre expérience d'achat",
                es: 'Este sitio web utiliza cookies para mejorar su experiencia de compra',
                pt: 'Este site utiliza cookies para melhorar a sua experiência de compra',
                it: 'Questo sito web utilizza i cookie per migliorare la tua esperienza di acquisto',
                de: 'Diese Website verwendet Cookies, um Ihr Einkaufserlebnis zu verbessern',
                da: 'Denne hjemmeside bruger cookies til at forbedre din shoppingoplevelse',
                nl: 'Deze website gebruikt cookies om uw winkelervaring te verbeteren.'
            },
            'Read more': {
                fr: 'En savoir plus',
                es: 'Leer más',
                pt: 'Leia mais',
                it: 'Per saperne di più',
                de: 'Mehr lesen',
                da: 'Læs mere',
                nl: 'Lees meer'
            },
            'Accept': {
                fr: 'Accepter',
                es: 'Aceptar',
                pt: 'Aceitar',
                it: 'Accettare',
                de: 'Akzeptieren',
                da: 'Acceptere',
                nl: 'Accepteer'
            },
            'Decline': {
                fr: 'Refuser',
                es: 'Rechazar',
                pt: 'Recusar',
                it: 'Rifiutare',
                de: 'Ablehnen',
                da: 'Nægte',
                nl: 'Weiger'
            }
        };
        function applyTranslations(root) {
            root.querySelectorAll('span, button, a').forEach(function(el) {
                const original = el.textContent.trim();
                const translated = dict[original] && dict[original][lang];
                if (translated && el.textContent.trim() !== translated) {
                    el.textContent = translated;
                }
            });
        }
        const start = Date.now();
        (function waitForHost() {
            const host = document.querySelector('pandectes-cmp');
            const root = host && host.shadowRoot;

            if (root) {
                applyTranslations(root);

                const observer = new MutationObserver(function() {
                    applyTranslations(root);
                });

                observer.observe(root, {
                    childList: true,
                    subtree: true,
                    characterData: true
                });
                return;
            }

            if (Date.now() - start < 20000) {
                setTimeout(waitForHost, 300);
            }
        })();
    }
    initPandectesTranslation(lang);

    // Add clickevents on multicolumn elements (photos) that have href inside
    $("ul.multicolumn-list li").each( function() {
        var anchor = $(this).find("a");
        if (anchor.length > 0) {
            var href = anchor.attr('href');
            $(this).click(function() {
                window.location.href = href;
            });
        }
    });

    // apply css to pify-app forms on B2B page
    async function adjustB2Bform() {
        await new Promise(resolve => setTimeout(resolve, 7000));
        var iframe = $("#form-iframe-30451").contents();
        var formheader = iframe.find(".form-header");
        var body = iframe.find("body");
        $("div.pifyform iframe").contents().find(".form-header").css({
            "min-height": "auto",
            "background-size": "contain",
            "width": "100%",
            "height": "0",
            "padding-top": "33%"
        });
    }
    adjustB2Bform();
  
    //add payment logos to footer
    // PAYPAL DISABLED if (lang === 'fr' || lang === 'pt' || lang === 'de') {
    if (lang === 'blabla') {
        $(".footer__payment ul").append(
            '<li class="list-payment__item">' +
            '<svg class="icon icon--full-color" xmlns="http://www.w3.org/2000/svg" role="img" width="62px" height="17px" viewBox="0 0 124 33" enable-background="new 0 0 124 33" aria-labelledby="pi-paypal"><title id="pi-visa">Visa</title>' +
            '<path fill="#253B80" d="M46.211,6.749h-6.839c-0.468,0-0.866,0.34-0.939,0.802l-2.766,17.537c-0.055,0.346,0.213,0.658,0.564,0.658  h3.265c0.468,0,0.866-0.34,0.939-0.803l0.746-4.73c0.072-0.463,0.471-0.803,0.938-0.803h2.165c4.505,0,7.105-2.18,7.784-6.5  c0.306-1.89,0.013-3.375-0.872-4.415C50.224,7.353,48.5,6.749,46.211,6.749z M47,13.154c-0.374,2.454-2.249,2.454-4.062,2.454  h-1.032l0.724-4.583c0.043-0.277,0.283-0.481,0.563-0.481h0.473c1.235,0,2.4,0,3.002,0.704C47.027,11.668,47.137,12.292,47,13.154z"/>' +
            '<path fill="#253B80" d="M66.654,13.075h-3.275c-0.279,0-0.52,0.204-0.563,0.481l-0.145,0.916l-0.229-0.332  c-0.709-1.029-2.29-1.373-3.868-1.373c-3.619,0-6.71,2.741-7.312,6.586c-0.313,1.918,0.132,3.752,1.22,5.031  c0.998,1.176,2.426,1.666,4.125,1.666c2.916,0,4.533-1.875,4.533-1.875l-0.146,0.91c-0.055,0.348,0.213,0.66,0.562,0.66h2.95  c0.469,0,0.865-0.34,0.939-0.803l1.77-11.209C67.271,13.388,67.004,13.075,66.654,13.075z M62.089,19.449  c-0.316,1.871-1.801,3.127-3.695,3.127c-0.951,0-1.711-0.305-2.199-0.883c-0.484-0.574-0.668-1.391-0.514-2.301  c0.295-1.855,1.805-3.152,3.67-3.152c0.93,0,1.686,0.309,2.184,0.892C62.034,17.721,62.232,18.543,62.089,19.449z"/>' +
            '<path fill="#253B80" d="M84.096,13.075h-3.291c-0.314,0-0.609,0.156-0.787,0.417l-4.539,6.686l-1.924-6.425  c-0.121-0.402-0.492-0.678-0.912-0.678h-3.234c-0.393,0-0.666,0.384-0.541,0.754l3.625,10.638l-3.408,4.811  c-0.268,0.379,0.002,0.9,0.465,0.9h3.287c0.312,0,0.604-0.152,0.781-0.408L84.564,13.97C84.826,13.592,84.557,13.075,84.096,13.075z  "/>' +
            '<path fill="#179BD7" d="M94.992,6.749h-6.84c-0.467,0-0.865,0.34-0.938,0.802l-2.766,17.537c-0.055,0.346,0.213,0.658,0.562,0.658  h3.51c0.326,0,0.605-0.238,0.656-0.562l0.785-4.971c0.072-0.463,0.471-0.803,0.938-0.803h2.164c4.506,0,7.105-2.18,7.785-6.5  c0.307-1.89,0.012-3.375-0.873-4.415C99.004,7.353,97.281,6.749,94.992,6.749z M95.781,13.154c-0.373,2.454-2.248,2.454-4.062,2.454  h-1.031l0.725-4.583c0.043-0.277,0.281-0.481,0.562-0.481h0.473c1.234,0,2.4,0,3.002,0.704  C95.809,11.668,95.918,12.292,95.781,13.154z"/>' +
            '<path fill="#179BD7" d="M115.434,13.075h-3.273c-0.281,0-0.52,0.204-0.562,0.481l-0.145,0.916l-0.23-0.332  c-0.709-1.029-2.289-1.373-3.867-1.373c-3.619,0-6.709,2.741-7.311,6.586c-0.312,1.918,0.131,3.752,1.219,5.031  c1,1.176,2.426,1.666,4.125,1.666c2.916,0,4.533-1.875,4.533-1.875l-0.146,0.91c-0.055,0.348,0.213,0.66,0.564,0.66h2.949  c0.467,0,0.865-0.34,0.938-0.803l1.771-11.209C116.053,13.388,115.785,13.075,115.434,13.075z M110.869,19.449  c-0.314,1.871-1.801,3.127-3.695,3.127c-0.949,0-1.711-0.305-2.199-0.883c-0.484-0.574-0.666-1.391-0.514-2.301  c0.297-1.855,1.805-3.152,3.67-3.152c0.93,0,1.686,0.309,2.184,0.892C110.816,17.721,111.014,18.543,110.869,19.449z"/>' +
            '<path fill="#179BD7" d="M119.295,7.23l-2.807,17.858c-0.055,0.346,0.213,0.658,0.562,0.658h2.822c0.469,0,0.867-0.34,0.939-0.803  l2.768-17.536c0.055-0.346-0.213-0.659-0.562-0.659h-3.16C119.578,6.749,119.338,6.953,119.295,7.23z"/>' +
            '<path fill="#253B80" d="M7.266,29.154l0.523-3.322l-1.165-0.027H1.061L4.927,1.292C4.939,1.218,4.978,1.149,5.035,1.1  c0.057-0.049,0.13-0.076,0.206-0.076h9.38c3.114,0,5.263,0.648,6.385,1.927c0.526,0.6,0.861,1.227,1.023,1.917  c0.17,0.724,0.173,1.589,0.007,2.644l-0.012,0.077v0.676l0.526,0.298c0.443,0.235,0.795,0.504,1.065,0.812  c0.45,0.513,0.741,1.165,0.864,1.938c0.127,0.795,0.085,1.741-0.123,2.812c-0.24,1.232-0.628,2.305-1.152,3.183  c-0.482,0.809-1.096,1.48-1.825,2c-0.696,0.494-1.523,0.869-2.458,1.109c-0.906,0.236-1.939,0.355-3.072,0.355h-0.73  c-0.522,0-1.029,0.188-1.427,0.525c-0.399,0.344-0.663,0.814-0.744,1.328l-0.055,0.299l-0.924,5.855l-0.042,0.215  c-0.011,0.068-0.03,0.102-0.058,0.125c-0.025,0.021-0.061,0.035-0.096,0.035H7.266z"/>' +
            '<path fill="#179BD7" d="M23.048,7.667L23.048,7.667L23.048,7.667c-0.028,0.179-0.06,0.362-0.096,0.55  c-1.237,6.351-5.469,8.545-10.874,8.545H9.326c-0.661,0-1.218,0.48-1.321,1.132l0,0l0,0L6.596,26.83l-0.399,2.533  c-0.067,0.428,0.263,0.814,0.695,0.814h4.881c0.578,0,1.069-0.42,1.16-0.99l0.048-0.248l0.919-5.832l0.059-0.32  c0.09-0.572,0.582-0.992,1.16-0.992h0.73c4.729,0,8.431-1.92,9.513-7.476c0.452-2.321,0.218-4.259-0.978-5.622  C24.022,8.286,23.573,7.945,23.048,7.667z"/>' +
            '<path fill="#222D65" d="M21.754,7.151c-0.189-0.055-0.384-0.105-0.584-0.15c-0.201-0.044-0.407-0.083-0.619-0.117  c-0.742-0.12-1.555-0.177-2.426-0.177h-7.352c-0.181,0-0.353,0.041-0.507,0.115C9.927,6.985,9.675,7.306,9.614,7.699L8.05,17.605  l-0.045,0.289c0.103-0.652,0.66-1.132,1.321-1.132h2.752c5.405,0,9.637-2.195,10.874-8.545c0.037-0.188,0.068-0.371,0.096-0.55  c-0.313-0.166-0.652-0.308-1.017-0.429C21.941,7.208,21.848,7.179,21.754,7.151z"/>' +
            '<path fill="#253B80" d="M9.614,7.699c0.061-0.393,0.313-0.714,0.652-0.876c0.155-0.074,0.326-0.115,0.507-0.115h7.352  c0.871,0,1.684,0.057,2.426,0.177c0.212,0.034,0.418,0.073,0.619,0.117c0.2,0.045,0.395,0.095,0.584,0.15  c0.094,0.028,0.187,0.057,0.278,0.086c0.365,0.121,0.704,0.264,1.017,0.429c0.368-2.347-0.003-3.945-1.272-5.392  C20.378,0.682,17.853,0,14.622,0h-9.38c-0.66,0-1.223,0.48-1.325,1.133L0.01,25.898c-0.077,0.49,0.301,0.932,0.795,0.932h5.791  l1.454-9.225L9.614,7.699z"/>' +
            '</svg></li>'
        );
    }
    const myBankLogo='<li class="list-payment__item list-payment__item--mybank"><span class="payment-badge payment-badge--mybank"><svg class="icon icon--full-color icon--mybank" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="-153 -46 652 652" aria-labelledby="pi-mybank-title pi-mybank-desc"><title id="pi-mybank-title">MyBank</title><desc id="pi-mybank-desc">MyBank payment method logo</desc><g><path fill="#204866" d="M281,243.3c-23.1-0.2-33.9,13.1-33.9,13.1c-7,7.5-2.5,17.5,4.4,18.3c9.9,1.1,9.8-7.2,25-10.9c13.3-3.2,13.9,9.1,13.9,9.1c-56.8-1.4-54.1,46.3-34.8,56.4c18.5,9.7,35.9-2.5,35.9-2.5s0.6,6.6,9.8,6.6c10.5,0,10.5-10.5,10.5-10.5l0-46.4C311,242.5,281,243.3,281,243.3 M276.5,310.5c0,0-14.9,3-14.7-7.6c0.1-10.6,27.1-10,29.8-9.1C291.6,293.7,292.5,305.8,276.5,310.5"/><path fill="#204866" d="M464.5,314.6l-23.2-34.9l17-16.1c0,0,7.9-7.3,1.4-14.5c-7.1-8-15.7-0.1-15.7-0.1l-21.4,19.9V229c0-5.7-4.6-10.4-10.4-10.4c-5.7,0-10.4,4.6-10.4,10.4v93.9c0,5.7,4.6,10.4,10.4,10.4c5.7,0,10.4-4.6,10.4-10.4v-25l3.9-3.9l21,32.9c0,0,6.8,11.4,16.9,4.1C472,325.5,464.5,314.6,464.5,314.6"/></g><g><path fill="#204866" d="M390.6,276.4c0-33.9-28.3-38.7-47.5-27.9c0,0,0,0.1,0,0.1c-1.4-4.1-5.3-7.1-9.9-7.1c-5.8,0-10.6,4.7-10.6,10.6v70.7c0,5.8,4.7,10.6,10.6,10.6c5.8,0,10.6-4.7,10.6-10.6l-0.1-47.7c0,0,2.6-3,6.7-6c9.9-7,19.3-4.6,19.3,7.4l0.3,46.5c0,5.8,4.7,10.4,10.4,10.4c5.7,0,10.4-4.7,10.4-10.4L390.6,276.4z"/><path fill="#27BCED" d="M86.3,334.7c2.4-4,2.8-6.9,2.8-6.9l-23.9-62.5c0,0-4.3-12.1,5.2-15.7c10.1-3.8,13.8,5.9,14.5,7.9c0.8,2,15.1,40.2,15.1,40.2l13.8-40.1c0,0,4-12.5,15-8c9.1,3.7,4.4,15.9,4.4,15.9s-14.1,41.8-26,72.1c-7.1,18.1-13.1,19.9-20,21.6c-9.2,2.3-26.7,1.1-26.7-10.3c0-9.1,9.3-9.6,13.5-9.5C74.4,339.4,83,340.2,86.3,334.7"/></g><g><path fill="#27BCED" d="M30.8,229.7L9,290L-14.8,230c0,0-3.5-11.3-13.5-11.3c-11.5,0-11.1,9.1-11.4,11.3c-0.3,2.2,0,93.7,0,93.7s-0.1,9.6,10.4,9.6c10.8,0,10.3-9.7,10.4-9.7c0.1,0,0-48.3,0-48.3l17.5,48.3c0,0,2.6,9.5,10.7,9.3c8.1-0.2,10.4-9.3,10.4-9.3l14.7-48.2v48.2c0,0,0,9.7,10.6,9.7c10.3,0,10.3-9.7,10.3-9.7l0-93.5c0,0,0-11.4-11.2-11.4C34.9,218.8,31.4,227.7,30.8,229.7c-0.1,0.2-0.1,0.4-0.1,0.4"/><path fill="#27BCED" d="M467.9,370.2H283.5l-135.4,0l0.1,0.1c-26.8,31.3-66.5,51.3-111,51.3c-80.6,0-145.9-65.3-145.9-145.9c0-80.6,65.3-145.9,145.9-145.9c44.6,0,84.6,20.1,111.3,51.6h29.3c-30.4-45.3-82-75.1-140.6-75.1c-93.6,0-169.4,75.9-169.4,169.4s75.8,169.4,169.4,169.4c49.1,0,93.2-21,124.1-54.3l292.6-0.3L467.9,370.2z"/></g><g><path fill="#204866" d="M222.6,271.9c0.6-0.8,7.6-6.5,7-21.7c-1.1-30.7-27.8-30.4-33.7-30.5c-9.5-0.3-15.2-0.2-32.7,0c-14.8,0.1-14.6,13.5-14.6,13.5v100.1h49.7c26.6,0,36.5-14.6,36.5-35.1C234.8,277.6,222.6,271.9,222.6,271.9 M170,240.9h27.5c5.5,0.1,11.3,3.1,11.3,11.3c0,8.6-5,11.3-11.3,11.3H170V240.9z M199.4,312.9H170v-28.1h29.4c7.1,0.4,14,4,14,14C213.4,309.1,207.1,312.9,199.4,312.9"/></g></svg></span></li>';
    const paymentCountry = window.zwembadPaymentContext?.country;

    if (["IT", "ES", "FR", "DE"].includes(paymentCountry)) {
        $(".footer__payment ul").each(function () {
            const $list = $(this);

            if (!$list.find(".list-payment__item--mybank").length) {
                $list.append(myBankLogo);
            }
        });
    }
    //various scroll events
    $("#Slide-template--23968505495877__multicolumn_RdmBFY-8 a").on("click", function(event) {
        event.preventDefault();
        var element = document.getElementById("shopify-section-template--23968505495877__multicolumn_FgMHg8");
        element.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
    });
    $("#Slide-template--23968505495877__multicolumn_RdmBFY-6 a").on("click", function(event) {
        event.preventDefault();
        var element = document.getElementById("shopify-section-template--23968505495877__multicolumn_FgMHg8");
        element.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
    });

    $("#Slide-template--23968505495877__multicolumn_RdmBFY-1 a").on("click", function(event) {
        event.preventDefault();
        var element = document.getElementById("shopify-section-template--23968505495877__multirow_xm4jLi");
        element.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
    });

    $("#Slide-template--23968505495877__multicolumn_RdmBFY-5 a:first-child").on("click", function(event) {
        event.preventDefault();
        var element = document.getElementById("shopify-section-template--23968505495877__multicolumn_t8Ljdn");
        element.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
    });

    $("#Slide-template--23968505495877__multicolumn_RdmBFY-5 a:last-child").on("click", function(event) {
        event.preventDefault();
        var element = document.getElementById("shopify-section-template--23968505495877__multicolumn_pL9EV6");
        element.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
    });
    $("#Slide-template--23968505495877__multicolumn_t8Ljdn-2 .rte a").on("click", function(event) {
        event.preventDefault();
        var element = document.getElementById("shopify-section-template--23968505495877__multicolumn_pL9EV6");
        element.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
    });

    $("#shopify-section-template--23968505495877__multicolumn_RdmBFY a.button").on("click", function(event) {
        event.preventDefault();
        var element = document.getElementById("shopify-section-template--23968505495877__collection_list_A3wjew");
        element.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
    });

    $("#Slide-template--23968505495877__multicolumn_t8Ljdn-1 .rte a").on("click", function(event) {
        event.preventDefault();
        var element = document.getElementById("shopify-section-template--23968505495877__image_with_text_6dRExX");
        element.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
    });
});